import { useState, useEffect } from "react";
// mui
import { Container } from "@mui/material";
// components
import ControlledOpenSelect from "src/components/UI/LeftCard/Menu";
import PrimarySearchAppBar from "src/components/UI/LeftCard/Search";
import ControlledOpenSelect2 from "src/components/UI/LeftCard/Menu2";
import ControlledOpenSelect4 from "src/components/UI/LeftCard/Menu4";
import ControlledOpenSelect3 from "src/components/UI/LeftCard/Menu3";
import ControlledOpenSelect5 from "src/components/UI/LeftCard/Menu5";
import ControlledOpenSelect6 from "src/components/UI/LeftCard/Menu6";
import BasePanel from "src/components/UI/Shared/BasePanel";
// assets
import styles from "src/components/UI/LeftCard/assets/scss/Card.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

interface BasicCardProps {}
const BasicCard = ({}: BasicCardProps) => {
  const dispatch = useDispatch();
  const activePanel = useSelector((state: any) => state.app.activePanel);
  const previousNavigation = useSelector(
    (state: any) => state.app.previousNavigation
  );

  const [query, setQuery] = useState(false);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason !== "backdropClick") {
      dispatch(appActions.setActivePanel(undefined));
    }
  };
  const handleQuerystart = (state: boolean) => {
    setQuery(state);
  };
  useEffect(() => {
    if (previousNavigation === "/Geo") {
      dispatch(
        appActions.setSearchString({
          menu1: "",
          menu2: "",
          menu3: "",
          menu4: "",
          menu5: "",
          menu6: "",
        })
      );
    }
  }, [previousNavigation]);
  return (
    <BasePanel
      openModal={activePanel === "toolbox"}
      onClose={handleClose}
      panelName={!query ? "Tools" : "Search"}
      minH="60%"
    >
      <Container className={`${styles.container} `}>
        <PrimarySearchAppBar queryStart={handleQuerystart} />
        {query && (
          <>
            <div style={{ display: "none" }}>
              <ControlledOpenSelect />
              <ControlledOpenSelect2 />
              <ControlledOpenSelect3 />
              <ControlledOpenSelect4 />
              <ControlledOpenSelect5 />
              <ControlledOpenSelect6 />
            </div>
          </>
        )}
        {!query && (
          <>
            <ControlledOpenSelect />
            <ControlledOpenSelect2 />
            <ControlledOpenSelect3 />
            <ControlledOpenSelect4 />
            <ControlledOpenSelect5 />
            <ControlledOpenSelect6 />
          </>
        )}
      </Container>
    </BasePanel>
  );
};
export default BasicCard;
